import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../apiConfig';
import { motion } from 'framer-motion';

function Leagues() {
    const [divisions, setDivisions] = useState([]);
    const fadeIn = {
        hidden: { opacity: 0, y: 30 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } }
    };

    useEffect(() => {
        let isMounted = true;
        axios.get(`${API_BASE_URL}/currentDivision`)
            .then((response) => {
                if (isMounted) {
                    setDivisions(response.data);
                }
            })
            .catch((error) => {
                console.error("Error fetching divisions:", error);
            });
        return () => { isMounted = false; };
    }, []);

    return (
        <div style={{ 
            background: '#f8f9fa', 
            minHeight: '100vh', 
            paddingBottom: '80px',
            position: 'relative',
        }}>
            {/* Title Header */}
            <div style={{
                padding: '60px 24px 40px',
                textAlign: 'center',
            }}>
                <motion.h1 
                    initial={{ opacity: 0, y: -20 }}
                    animate={{ opacity: 1, y: 0 }}
                    style={{
                        fontFamily: 'var(--fontAnton)',
                        fontSize: 'max(48px, 6vw)',
                        fontWeight: 400,
                        color: '#040960',
                        margin: 0,
                        textTransform: 'uppercase',
                        letterSpacing: '4px',
                        lineHeight: 1
                    }}
                >
                    Divisions
                </motion.h1>
                <div style={{ 
                    width: '60px', 
                    height: '4px', 
                    background: 'var(--yellow)', 
                    margin: '20px auto 0' 
                }} />
            </div>

            {/* Divisions Grid */}
            <div style={{ 
                maxWidth: 'var(--maxWidth)', 
                margin: '0 auto', 
                padding: '0 24px',
            }}>
                <div id="Leagues-wrapper" style={{ 
                    display: 'grid', 
                    gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', 
                    gap: '24px' 
                }}>
                    {divisions.map((division, index) => (
                        <motion.div
                            key={division.PCID}
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: true }}
                            variants={fadeIn}
                            custom={index}
                        >
                            <Link
                                style={{ textDecoration: 'none' }}
                                to={division.PCID.toString()}
                                onClick={() => window.scrollTo(0, 0)}
                            >
                                <motion.div 
                                    whileHover={{ y: -5, background: 'linear-gradient(135deg, #060D8A 0%, #040960 100%)', boxShadow: '0 12px 24px rgba(4,9,96,0.2)' }}
                                    style={{
                                        background: 'linear-gradient(135deg, #040960 0%, #060D8A 100%)',
                                        borderBottom: '4px solid var(--yellow)',
                                        borderRadius: '8px',
                                        padding: '40px 20px',
                                        textAlign: 'center',
                                        color: '#ffffff',
                                        fontFamily: 'var(--fontAnton)',
                                        fontSize: '24px',
                                        textTransform: 'uppercase',
                                        letterSpacing: '2px',
                                        transition: 'all 0.3s ease',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        minHeight: '120px',
                                        boxShadow: '0 4px 15px rgba(0,0,0,0.1)'
                                    }}
                                >
                                    {division.name}
                                </motion.div>
                            </Link>
                        </motion.div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default Leagues;